import { render, staticRenderFns } from "./TodoPage.vue?vue&type=template&id=a3a50068&"
import script from "./TodoPage.vue?vue&type=script&lang=js&"
export * from "./TodoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports